export const getProductType = (category) =>
  category === "Smart Watches" ||
  category === "Connected Smartwatches" ||
  location?.pathname?.includes("smart-watches") ||
  String(category).toLowerCase().includes("smartwatch")
    ? "smart-watches"
    : category === "Phones" || location?.pathname?.includes("basic-phones")
    ? "basic-phones"
    : category === "BroadbandAccess Devices" ||
      location?.pathname?.includes("mobile-hotspots")
    ? "mobile-hotspots"
    : category === "Tablets" || location?.pathname?.includes("tablets")
    ? "tablets"
    : category === "Connected Laptops" ||
      location?.pathname?.includes("laptops")
    ? "laptops"
    : category === "Connected Devices" ||
      location?.pathname?.includes("desk-conference-phones")
    ? "desk-conference-phones"
    : "smartphones";
